import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi } from '@/hooks';
import { sidebarItems } from './sidebar';
import { JuntaDirectiva as JuntaDirectivaComponent } from '@/components';

import { ROUTES } from '@/constants';

import type { JuntaDirectiva as JuntaDirectivaType } from '@/interfaces/strapi';
import { SectionTitle } from '@/components';
import { getJuntaDirectiva } from '@/services/strapi';

export const JuntaDirectiva = (): ReactElement => {
	const { loading, data } = useStrapiApi<JuntaDirectivaType[], null>(getJuntaDirectiva, {
		autoFetch: true,
		params: null,
	});

	usePageBreadcrumb([
		{ label: 'El Colegio', to: ROUTES.COLEGIO_PRESENTACION },
		{ label: 'Organización', to: ROUTES.COLEGIO_JUNTA_DIRECTIVA },
		{ label: 'Junta Directiva' },
	]);

	// Sidebar estable (memoizado)
	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return (
		<div>
			<SectionTitle title="Junta Directiva" tag="h1" align="left" className="u-mb-16" />
			{data && !loading && <JuntaDirectivaComponent data={data} />}
		</div>
	);
};
